export default __webpack_public_path__ + "img/pin_icons/laptop_w.svg";